module.exports = __webpack_public_path__ + "static/media/mad.3492fb9c.png";